import Vue from "vue"
import Vuex from "vuex"
import { api } from "@/utils/api.js"
import * as types from "@/store/mutations_types.js"


Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    login: false,
    Browser: {},
    toggleSidebar: false,
    toggleMainSidebar: true,
    onLoading: false,
    onLogin: true,
    smallDevice: false,
    UserLoginData: {
      userName:null,
      isVendorUser:null
    },
    alertMessage: {},
    alertMessageCb: {},
    language: "",
    Loading: null,
    /***************-BASE-***************/
    regionBase: [],
    areaBase: [],
    factoryBase: [],
    enterReasonBase: [],
    cartypeBase: [],
    carColorBase: [],
    codeCultureBase: [],
    /***************-VENDOR-***************/
    carDataInfo: [],
    driverDataInfo: [],
    /***************-RESERVE-***************/
    reserveTable: [],
    reserveInfo: {},
    updateReserve: {},

    /****************KEEP-SEARCH RESERVE****************/
    keepSearchVendorReserve: {
      reserveArea: "",
      enterReason: "",
      reserveFactory: "",
      reserveStatus: "",
      reserveArriveTime: [],
      applyDatetime: [],
    },
  },
  getters: {
    isLogin: (state) => state.login,
    getUserLoginData: (state) => state.UserLoginData,
    toggleSidebar: (state) => state.toggleSidebar,
    toggleMainSidebar: (state) => state.toggleMainSidebar,
    getSmallDevice: (state) => state.smallDevice,
    onLoading: (state) => state.onLoading,
    PageTreeDataOrg(state) {
      return state.PageTreeDataOrg
    },
    alertMessage: (state) => state.alertMessage,
    alertMessageCb: (state) => state.alertMessageCb,
    getLanguage: (state) => state.language,
    /***************-KEEP-***************/
    keepSearchVendorReserve: (state) => state.keepSearchVendorReserve,
    /***************-BASE-***************/
    regionBase: (state) => state.regionBase,
    areaBase: (state) => state.areaBase,
    factoryBase: (state) => state.factoryBase,
    cartypeBase: (state) => state.cartypeBase,
    carColorBase: (state) => state.carColorBase,
    enterReasonBase: (state) => state.enterReasonBase,
    /***************-VENDOR-***************/
    carDataInfo: (state) => state.carDataInfo,
    driverDataInfo: (state) => state.driverDataInfo,
    /***************-RESERVE-***************/
    reserveTable: (state) => state.reserveTable,
    reserveInfo: (state) => state.reserveInfo,
    updateReserve: (state) => state.updateReserve,
    codeCultureBase: (state) => state.codeCultureBase,
    getSysCodeText: (state) => (type, code) => {
      if (
        type &&
        code &&
        state.codeCultureBase[type] &&
        state.codeCultureBase[type][code] &&
        state.codeCultureBase[type][code][state.language]
      ) {
        return state.codeCultureBase[type][code][state.language]
      } else return ""
    },    
  },
  mutations: {
    /***********GENERAL***************/
    [types.LOGIN](state, isLogin) {
      state.login = isLogin
    },
    [types.VENDORINFO](state, payload) {
      state.UserLoginData.userName = payload.userName
      state.UserLoginData.isVendorUser = payload.isVendorUser
    },
    [types.LOGOUT](state) {
      state.UserLoginData.userName = null
      state.UserLoginData.isVendorUser = null
    },
    LANGUAGE(state, language) {
      state.language = language
    },    
    TOGGLE_SIDEBAR(state) {
      state.toggleSidebar = !state.toggleSidebar
    },
    TOGGLE_MAINSIDEBAR(state) {
      state.toggleMainSidebar = !state.toggleMainSidebar
    },
    ONLOADING(state, parameter) {
      state.onLoading = parameter.paramter
    },
    SMALL_DEVICE(state, smallDevice) {
      state.smallDevice = smallDevice
    },
    LOGIN_VENDOR(state, parameter) {
      state.UserLoginData.OACode = parameter.result.oacode
      state.UserLoginData.pagePermission = parameter.result.role
      state.UserLoginData.userLoginRole = parameter.result.role
    },
    LOGOUT_VENDOR(state, parameter) {
      state.UserLoginData.OACode = ""
      state.UserLoginData.pagePermission = ""
      state.UserLoginData.userLoginRole = ""
    },
    ALERT_MESSAGE(state, data) {
      state.alertMessage = data
    },
    STORE_CALLBACK(state, fn) {
      state.storeCallback = fn
    },
    /*********KEEP**********/
    KEEP_SEARCHVENDORRSV(state, data) {
      if (data.active == true) {
        //keep
        state.keepSearchVendorReserve.reserveArea = data.reserveArea
        state.keepSearchVendorReserve.enterReason = data.enterReason
        state.keepSearchVendorReserve.reserveFactory = data.reserveFactory
        state.keepSearchVendorReserve.reserveStatus = data.reserveStatus
        state.keepSearchVendorReserve.reserveArriveTime = data.reserveArriveTime
        state.keepSearchVendorReserve.applyDatetime = data.applyDatetime
      } else {
        //clear
        state.keepSearchVendorReserve.reserveArea = ""
        state.keepSearchVendorReserve.enterReason = ""
        state.keepSearchVendorReserve.reserveFactory = ""
        state.keepSearchVendorReserve.reserveStatus = ""
        state.keepSearchVendorReserve.reserveArriveTime = ""
        state.keepSearchVendorReserve.applyDatetime = ""
      }
    },
    /***************-BASE-***************/
    GET_REGION(state, data) {
      state.regionBase = data
    },
    GET_AREA(state, data) {
      state.areaBase = data
    },
    GET_FACTORY(state, data) {
      state.factoryBase = data
    },
    GET_ENTER_REASON(state, data) {
      state.enterReasonBase = data
    },
    GET_CARTYPE(state, data) {
      state.cartypeBase = data
    },
    GET_CAR_COLOR(state, data) {
      state.carColorBase = data
    },
    /***************-VENDOR-***************/
    GET_VENDOR_INFO(state, data) {
      state.carDataInfo = data.carData
      state.driverDataInfo = data.driverData
    },
    /***************-RESERVE-***************/
    GET_RESERVE_TABLE(state, data) {
      state.reserveTable = data
    },
    GET_RESERVE_INFO(state, data) {
      state.reserveInfo = data
    },
    UPDATE_RESERVE(state, data) {
      state.updateReserve = data
    },
    GET_CODE_CULTURE(state, data) {
      state.codeCultureBase = data
    },    
  },
  actions: {
    /***************-GENERATE-***************/
    setLogin(context, isLogin) {
      context.commit(types.LOGIN, isLogin)
      if(!isLogin){
        context.commit(types.LOGOUT)
      }
    },
    setVendorInfo(context, payload){
      context.commit(types.VENDORINFO, payload)
    },
    setLanguage(context, language) {
      context.commit("LANGUAGE", language)
    },   
    setLogout(context) {
      context.commit(types.LOGOUT)
    }, 
    toggleSidebar({ commit }) {
      commit("TOGGLE_SIDEBAR")
    },
    toggleMainSidebar({ commit }) {
      commit("TOGGLE_MAINSIDEBAR")
    },
    onLoading(context, parameter) {
      context.commit("ONLOADING", parameter)
    },
    setSmallDevice(context, smallDevice) {
      context.commit("SMALL_DEVICE", smallDevice)
    },
    logoutVendor(context) {
      context.commit("LOGOUT_VENDOR")
    },
    loginVendor(context, parameter) {
      api
        .apiLoginVendor(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit(types.VENDORINFO, response.data)
          } else {
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateVendorPw(context, parameter) {
      api
        .apiUpdateVendorPw(parameter)
        .then((response) => {
          console.log(response.data)
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-KEEP-***************/
    KeepSearchVendorReserve(context, parameter) {
      context.commit("KEEP_SEARCHVENDORRSV", parameter)
    },
    /***************-BASE-***************/
    getRegion(context, parameter) {
      api
        .apiGetRegion(parameter)
        .then((response) => {
          context.commit("GET_REGION", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getArea(context, parameter) {
      api
        .apiGetArea(parameter)
        .then((response) => {
          context.commit("GET_AREA", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFactory(context, parameter) {
      api
        .apiGetFactory(parameter)
        .then((response) => {
          context.commit("GET_FACTORY", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getEnterReason(context) {
      api
        .apiGetEnterReason()
        .then((response) => {
          context.commit("GET_ENTER_REASON", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCartype(context) {
      api
        .apiGetCartype()
        .then((response) => {
          context.commit("GET_CARTYPE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCarColor(context) {
      api
        .apiGetCarColor()
        .then((response) => {
          context.commit("GET_CAR_COLOR", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setCodeCulture(context, parameter) {
      context.commit("GET_CODE_CULTURE", parameter)
    },    
    /***************-VENDOR-***************/
    getVendorInfo(context, parameter) {
      api
        .apiGetVendorInfo(parameter)
        .then((response) => {
          if (response.data.code == 1) {
            context.commit("GET_VENDOR_INFO", response.data.result)
          } else {
            context.commit("ALERT_MESSAGE", response.data.result)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /***************-RESERVE-***************/
    upsertReserveByUser(context, parameter) {
      api
        .apiUpsertReserveByUser(parameter)
        .then((response) => {
          context.commit("ALERT_MESSAGE_CB", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReserveTable(context, parameter) {
      api
        .apiGetReserveTable(parameter)
        .then((response) => {
          if (response.data.code == 0) {
            context.commit("GET_RESERVE_TABLE", response.data.result)
          } else {
            context.commit("ALERT_MESSAGE", response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getReserveInfo(context, parameter) {
      api
        .apiGetReserveInfo(parameter)
        .then((response) => {
          context.commit("GET_RESERVE_INFO", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateReserveInfo(context, payload) {
      var parameter = payload.params
      var cb = payload.cb

      api
        .apiUpdateReserveInfo(parameter)
        .then((response) => {
          response.data.cb = cb
          context.commit("ALERT_MESSAGE", response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
})
